import { find, get } from 'lodash'
import { createSelector } from 'reselect'
import { STATES_BY_ABBREV } from 'src/constants/states'
import {
  getThe,
  getTheBoolean,
  getFrom,
  select
} from 'src/store/selectors/utils'
import { getAuthEmail } from 'src/auth'
import { selectCurrentCELs, selectAll } from './dictionary'

const getHome = state => state.home
const selectFromHome = select(getHome)
export const selectHomeLoading = selectFromHome(getThe('loading'))
export const selectHomeFetchId = selectFromHome(getThe('fetchId'))
export const selectHomeIsErrored = selectFromHome(getTheBoolean('errorModal'))
export const selectHomeNotFound = selectFromHome(getTheBoolean('notFound'))
export const selectIsUnsubscribed = selectFromHome(
  getTheBoolean('isUnsubscribed')
)
export const selectShouldUnsubscribe = selectFromHome(
  getTheBoolean('shouldUnsubscribe')
)
export const selectHomeUpdateLoanBalanceRequested = selectFromHome(
  getTheBoolean('updateLoanBalanceRequested')
)
export const selectHomeData = selectFromHome(getThe('data'))
export const selectHasHomeData = selectFromHome(getTheBoolean('data'))

const getHomeData = state => state.home.data
export const selectFromHomeData = select(getHomeData)

export const getHomeId = getThe('id')
export const selectHomeId = selectFromHomeData(getHomeId)

export const selectMetadata = selectFromHomeData(getThe('metadata'))

export const getHomeUuid = getThe('uuid')
export const selectHomeUuid = selectFromHomeData(getHomeUuid)

const getAddress = getThe('address')
const getFromAddress = getFrom(getAddress)
const getZip = getFromAddress('zip')
const getState = getFromAddress('state')
export const getStreet = getFromAddress('street')

export const selectAddress = selectFromHomeData(getAddress)
export const selectZipcode = selectFromHomeData(getZip)
export const selectHomeAddressState = selectFromHomeData(getState)
export const selectStreet = selectFromHomeData(getStreet)
export const selectHomeAddressStateName = createSelector(
  selectHomeAddressState,
  abbrev => get(STATES_BY_ABBREV, abbrev)
)

export const selectWarnings = createSelector(
  selectHomeAddressState,
  selectAll,
  (hasState, dictionary) => ({
    showAVMDiffWarning: hasState && dictionary.showAvmDiffWarning(),
    showNonDisclosureStateWarning:
      hasState && dictionary.showNonDisclosureStateWarning()
  })
)

const getHomeUserFromAttribute = attrName => (home, attrValue) => {
  const def = get(home, 'users[0]')

  if (!(home && attrName && attrValue)) {
    return def
  }

  return find(home.users, { [attrName]: attrValue }) || def
}

export const getHomeUserFromEmail = getHomeUserFromAttribute('email')

export const selectCurrentHomeUser = createSelector(
  getHomeData,
  () => getAuthEmail(),
  getHomeUserFromEmail
)

export const selectHasRecentLoan = createSelector(
  selectCurrentCELs,
  dict => dict.hasRecentLoan()
)
